var _path, _path2, _path3, _circle, _circle2, _circle3, _path4, _path5, _path6, _rect, _rect2, _path7, _path8, _rect3, _path9, _path0, _circle4, _polygon, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _circle5, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _polygon2, _path27, _polygon3, _path28, _path29, _path30, _circle6, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawYoutubeTutorialXgp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 618.5,
    height: 567.88189,
    viewBox: "0 0 618.5 567.88189",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M333.94482,671.57974c-10.14013,6.98242-20.50927,14.18854-27.53076,24.30218-7.021,10.11371-10.08594,23.91974-4.44433,34.86322l-.14551.68207a26.3915,26.3915,0,0,0,25.48486-4.48913c8.92578-7.49189,11.72461-19.83472,14.00147-31.26349l6.73535-33.8042Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#f0f0f0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M343.71141,705.66908c-6.76417,1.49654-13.695,3.06129-19.4952,6.85012-5.7999,3.789-10.31778,10.3399-9.6903,17.23941l-.22011.32489a14.85042,14.85042,0,0,0,14.23834,3.04866c6.23868-2.019,10.30836-7.86324,13.91256-13.34122l10.661-16.20269Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#f0f0f0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M908.41175,196.23614H330.856a.83826.83826,0,0,1,0-1.67651H908.41175a.83826.83826,0,0,1,0,1.67651Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#cacaca"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.97324,
    cy: 9.22077,
    r: 9.22077,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90.82683,
    cy: 9.22077,
    r: 9.22077,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 122.68041,
    cy: 9.22077,
    r: 9.22077,
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M889.32666,171.69911H866.69385a1.6765,1.6765,0,1,1,0-3.353h22.63281a1.6765,1.6765,0,0,1,0,3.353Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M889.32666,177.986H866.69385a1.6765,1.6765,0,1,1,0-3.353h22.63281a1.6765,1.6765,0,0,1,0,3.353Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M889.32666,184.27289H866.69385a1.6765,1.6765,0,1,1,0-3.353h22.63281a1.67651,1.67651,0,0,1,0,3.353Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.52146,
    y: 66.12292,
    width: 383.08126,
    height: 229.68111,
    fill: "#f0f0f0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 479.54484,
    y: 66.12292,
    width: 120.70832,
    height: 72.37217,
    fill: "#f0f0f0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M866.92116,337.80175H795.1a3.38288,3.38288,0,0,1,0-6.76576h71.82119a3.38288,3.38288,0,0,1,0,6.76576Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#e4e4e4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M855.34129,326.22189H806.67984a3.38288,3.38288,0,0,1,0-6.76576h48.66145a3.38288,3.38288,0,0,1,0,6.76576Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#e4e4e4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 479.54484,
    y: 197.72852,
    width: 120.70832,
    height: 72.37217,
    fill: "#f0f0f0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M866.92116,469.40735H795.1a3.38288,3.38288,0,0,1,0-6.76576h71.82119a3.38288,3.38288,0,0,1,0,6.76576Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#e4e4e4"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M855.34129,457.82749H806.67984a3.38288,3.38288,0,0,1,0-6.76577h48.66145a3.38289,3.38289,0,0,1,0,6.76577Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#e4e4e4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.71892,
    cy: 161.09572,
    r: 28.58657,
    fill: "#9e616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "295.884 295.804 224.205 295.804 228.228 205.164 228.723 204.644 235.84 197.133 258.473 197.133 266.872 205.264 267.534 205.91 285.406 223.035 295.884 295.804",
    fill: "#4f7777"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M534.79631,461.86308h-54.4782c-.36019-34.68688-.64547-60.85709-.64547-60.85709l2.78325-1.69328.01679-.00839,30.554-18.55053,6.413-10.41947.03356.36883,1.88607,21.96222S531.61071,425.78473,534.79631,461.86308Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M608.92311,461.86308h-48.4762c-2.59047-11.75231-3.93994-22.943-3.353-32.27271,2.3805-38.1153-3.10989-59.25605-.72938-59.25605l1.25738.98913,14.95428,11.811,19.69075,7.21734,13.66334,5.01273,2.38051.87181v1.14841C608.31938,403.15192,608.37791,429.934,608.92311,461.86308Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M511.4244,336.09854s2.42881-4.26539,1.86415-18.51458,21.13347-6.19,39.26452-7.54932,14.293,23.78939,14.293,23.78939,1.308-1.495,4.10855-13.63245-3.55814-24.233-3.55814-24.233c-1.87272-12.75424-11.96538-8.6665-11.96538-8.6665,4.8605,1.89215,3.927,5.938,3.927,5.938-4.11425-7.21338-14.2069-3.12564-14.2069-3.12564-13.4607-8.44691-27.103,2.67661-27.103,2.67661-16.26119,3.69055-6.72462,16.62239-6.72462,16.62239C494.97023,317.66771,511.4244,336.09854,511.4244,336.09854Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M464.53416,461.86308c1.39122-27.82159,2.45582-49.64966,2.03669-51.33456-1.17347-4.68585,15.382-11.03142,15.885-11.21581l.00819-.00839h.0086l3.16022,1.70167,2.31338,60.85709Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M620.323,461.86308H595.72063L588.679,392.31332l2.90032-2.1208s.25172.05868.68763.15927c2.25485.56161,9.531,2.46446,13.66334,5.01273a8.28016,8.28016,0,0,1,2.38051,2.02022,2.43609,2.43609,0,0,1,.562,1.72679C608.6632,401.08141,614.02793,428.92817,620.323,461.86308Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M661.74118,489.94453H401.883a3.77214,3.77214,0,0,0,0,7.54427H661.74118a3.77214,3.77214,0,1,0,0-7.54427Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#cacaca"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M591.328,489.94453v7.54427H401.883a3.77214,3.77214,0,0,1,0-7.54427Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 300.57799,
    cy: 327.65761,
    r: 7.54427,
    fill: "#3f3d56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M531.81209,556.58558a15.57329,15.57329,0,1,1,15.57329-15.57329A15.59094,15.59094,0,0,1,531.81209,556.58558Zm0-29.94863a14.37535,14.37535,0,1,0,14.37534,14.37534A14.39173,14.39173,0,0,0,531.81209,526.637Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#4f7777"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M529.75536,549.39791a.599.599,0,0,1-.599-.599V533.22565a.599.599,0,1,1,1.19794,0v15.57329A.599.599,0,0,1,529.75536,549.39791Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#4f7777"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M533.86882,549.39791a.599.599,0,0,1-.599-.599V533.22565a.599.599,0,1,1,1.19795,0v15.57329A.599.599,0,0,1,533.86882,549.39791Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#4f7777"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M460.48272,541.01229A15.57329,15.57329,0,1,1,476.056,556.58558,15.59094,15.59094,0,0,1,460.48272,541.01229Zm1.198,0A14.37535,14.37535,0,1,0,476.056,526.637,14.39172,14.39172,0,0,0,461.68067,541.01229Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M482.7825,546.25554a.49816.49816,0,0,0,.24954-.92957l-7.47162-4.3137,7.47162-4.3137a.49818.49818,0,0,0-.4981-.86293l-8.2188,4.74516a.49828.49828,0,0,0,0,.86294l8.2188,4.74516A.496.496,0,0,0,482.7825,546.25554Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M471.76234,547.98581a.49813.49813,0,0,0,.49811-.49811V534.53688a.49811.49811,0,0,0-.99622,0V547.4877A.49813.49813,0,0,0,471.76234,547.98581Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M587.56816,556.58558a15.57329,15.57329,0,1,1,15.57329-15.57329A15.59094,15.59094,0,0,1,587.56816,556.58558Zm0-29.94863a14.37535,14.37535,0,1,0,14.37535,14.37534A14.39172,14.39172,0,0,0,587.56816,526.637Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M580.84167,546.25554a.49817.49817,0,0,1-.24954-.92957l7.47163-4.3137-7.47163-4.3137a.49819.49819,0,0,1,.49811-.86293l8.21879,4.74516a.49828.49828,0,0,1,0,.86294l-8.21879,4.74516A.496.496,0,0,1,580.84167,546.25554Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M591.86184,547.98581a.49813.49813,0,0,1-.49811-.49811V534.53688a.49811.49811,0,0,1,.99622,0V547.4877A.49813.49813,0,0,1,591.86184,547.98581Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#3f3d56"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M381.99345,552.74967a7.97,7.97,0,0,1,1.08851-12.17252l-7.66226-27.26669,14.02076,4.47645,5.12668,25.20662a8.01323,8.01323,0,0,1-12.57369,9.75614Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#ffb6b6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M378.246,416.90146l-2.9043-3.02253s-8.97943,6.16773-7.07952,25.28678c1.40332,14.122-3.03125,20.111-2.53565,61.15741L378.246,537.91366l14.48035-7.59055L382.25,483.94094Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#4f7777"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "98.359 555.931 108.742 555.931 113.682 515.882 98.357 515.883 98.359 555.931",
    fill: "#ffb6b6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M386.46063,718.60014l20.44784-.00083h.00083a13.03166,13.03166,0,0,1,13.031,13.03076v.42345l-33.479.00124Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.639 552.254 138.945 553.517 148.723 514.368 133.513 512.503 128.639 552.254",
    fill: "#ffb6b6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M417.17264,714.62551l20.29584,2.48858.00082.0001a13.03166,13.03166,0,0,1,11.34762,14.52027l-.05155.4203-33.23013-4.07463Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M383.72735,516.65381s-20.001,13.6693-10.001,50.6693L387.25,710.94094l16.06693-.1139,6.80537-70.86582,4.625-49.89008,15.45359,51.59055-12.71071,63.30449L436.25,706.94094l22.47638-73.61783L447.88732,528.50894Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M431.98733,409.99893l-10.17-8.18-26.97-1.11-19.50561,13.17s-2.01344,46.89579,11.18561,88.67l-6.92,17.45,69.19,8.68Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#4f7777"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.43163,
    cy: 201.47915,
    r: 23.13402,
    fill: "#ffb6b6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M416.25,338.94094h-5.14111a24.00282,24.00282,0,0,0-30.85889,23L372.24316,388.363a5.09932,5.09932,0,0,0,4.88038,6.57794h3.9082a11.50551,11.50551,0,0,0,2.00342-8.01281,23.64175,23.64175,0,0,1,1.5166,5.51355,9.714,9.714,0,0,1-.05127,2.49926H418.501a12.68828,12.68828,0,0,0-3.07422-9.14678,45.74437,45.74437,0,0,1,7.08545,9.14678h.63867a5.09929,5.09929,0,0,0,5.09912-5.09918V363.94094h13A25,25,0,0,0,416.25,338.94094Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#2f2e41"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M441.99345,550.74967a7.97,7.97,0,0,1,1.08851-12.17252l-7.66226-27.26669,14.02076,4.47645,5.12668,25.20662a8.01323,8.01323,0,0,1-12.57369,9.75614Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#ffb6b6"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M423.21734,415.1735l8.77-5.17457s13.79417-2.43173,15.26661,15.94622,3.59327,66.08374,3.59327,66.08374l4.30242,40.21548-15.96615,3.40452-18.35075-54.99508Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#4f7777"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M503.75,733.94094h-212a1,1,0,0,1,0-2h212a1,1,0,0,1,0,2Z",
    transform: "translate(-290.75 -166.05906)",
    fill: "#cacaca"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawYoutubeTutorialXgp1);
export default __webpack_public_path__ + "static/media/undraw_youtube-tutorial_xgp1.d3e741b2d1bf2f9e43a7ed6630433561.svg";
export { ForwardRef as ReactComponent };